const countryLanguageMap = {
  se: 'svSE',
  no: 'nbNO',
  fi: 'fiFI',
  dk: 'daDK'
};
export function countryToLanguage(country) {
  return countryLanguageMap[country];
}
